module.exports = __webpack_public_path__ + "img/8.16ceef00.jpg";